"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.create = exports.createMultiple = exports.getAll = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_1 = require("@main/common");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function createMultiple(numParticles, x, y, color) {
    for (var i = 0; i < numParticles; i++) {
        create(x + rando_sidecar_1.rando.i(-6, 6), y + rando_sidecar_1.rando.i(-6, 6), color);
    }
}
exports.createMultiple = createMultiple;
function create(x, y, color) {
    var frame = sprites_sidecar_1.sprites.voyTileParticlesRound[2];
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipSplatter, frame);
    image.tint = color;
    image.x = x;
    image.y = y;
    var id = common_1.createId();
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        image: image,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    // l.forEach(objs, (c) => {
    //   update(c)
    // })
    removeDead();
}
exports.updateAll = updateAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        c.image.destroy();
    });
}
exports.removeDead = removeDead;
